import { env } from './env';
import { CountryCode } from './types/country';

export const isVatableCountry = (countryCode: CountryCode) =>
  env.NEXT_PUBLIC_SITE_TYPE === 'D2C' && countryCode === 'GB';
